import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import * as React from "react";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";

import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { DeleteOnIcon, EditOnIcon } from "../../../../assets/icons/CustomIcons";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import CommonDynamicTableNew from "../../../../common/components/CommonTable/CommonDynamicTableNew";
import CheckBoxField from "../../../../common/components/FormFields/CheckBoxField";
import CreateableSelect from "../../../../common/components/FormFields/CreateableSelect";
import DropdownField from "../../../../common/components/FormFields/DropdownField";
import InputField from "../../../../common/components/FormFields/InputField";
import {
  fetchDrugDose,
  fetchDrugInstructions,
  fetchDrugName,
  fetchDrugRoute,
} from "../../../services/dischargeSummary/DischargeSummaryServices";
import { DischargeSummaryContext } from "./DischargeSummaryTabWise";
import { CapitalizeStatement } from "../../../../common/components/Custom Hooks/CapitalizeStatement";

let medicationHeaders = [
  {
    "Item Name": "",
    Dose: "",
    Route: "",
    Frequency: "",
    Instructions: "",
  },
];

const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "85%",
  maxHeight: "65%",
  // maxHeight: "80%",
  overflowY: "auto",
  bgcolor: "background.paper",
  border: "1px solid gray",
  boxShadow: 20,
  py: 2,
  px: 2,
  "&:focus": {
    outline: "none",
  },
};
const schema = yup.object().shape({
  // drugName
  drugName: yup
    .object()
    .nullable()
    .shape({
      value: yup.string().required("Required"),
      label: yup.string().required("Required"),
    })
    .required("Required"),

  // dosage
  dosage: yup
    .object()
    .nullable()
    .shape({
      value: yup.string().required("Required"),
      label: yup.string().required("Required"),
    })
    .required("Required"),

  // instructions
  // instructions: yup
  //   .object()
  //   .nullable()
  //   .shape({
  //     value: yup.string().required("Required"),
  //     label: yup.string().required("Required"),
  //   })
  //   .required("Required"),

  // route
  route: yup
    .object()
    .nullable()
    .shape({
      value: yup.string().required("Required"),
      label: yup.string().required("Required"),
    })
    .required("Required"),

  // duration
  duration: yup.string().nullable().required("Required"),
});
export default function MedicationPrescriptionModal(props) {
  const inputRefs = React.useRef([]);
  //
  const {
    allMedicationData,
    setAllMedicationData,
    //
    setDeletedMedicationData,
  } = React.useContext(DischargeSummaryContext);

  //
  const {
    open,
    handleClose,

    // allMedicationData,
    // setAllMedicationData,
    // //
    // setDeletedMedicationData,
  } = props;
  const [drugName, setDrugName] = useState();
  const [drugDose, setDrugDose] = useState();
  const [drugInstruction, setDrugInstrucForm] = useState();
  const [drugRoute, setDrugRoute] = useState();
  const [editIndex, setEditIndex] = useState(null);

  const [drugSearchString, setDrugSearchString] = useState();

  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: {
      // drugType: "",
      drugName: "",
      dosage: "",
      duration: "",
      genericName: "",
      quantity: "",
      refill: "",
      form: "",
      instructions: "",
      route: "",
      remark: "",
      startDate: "",
      isCurrentMedicine: false,
    },
  });
  const {
    formState: { errors },
    control,
    register,
  } = methods;

  console.log("allMedicationData", allMedicationData, editIndex);
  const onsubmit = (data) => {
    let itemObj = {
      itemName: data.drugName.label.toUpperCase(),
      dose: data.duration,
      route: data.route.label,
      frequency: data.dosage.label,
      instructions: data.instructions,
      isCurrentMedicine: data.isCurrentMedicine,
      medicationId: 0,
      isDelete: data.isDelete || false,
    };

    let arr = [...allMedicationData];

    if (editIndex !== null) {
      let medicationId = arr[editIndex].medicationId;
      itemObj.medicationId = medicationId;

      arr[editIndex] = itemObj;
      setEditIndex(null);
    } else {
      // Add new item
      arr.push(itemObj);
    }

    setAllMedicationData(arr);
    methods.reset();
  };

  useEffect(() => {
    getDrugDose();
    getDrugName();
    getDrugInstruction();
    getDrugRoute();
  }, [drugSearchString]);

  //   DrugName
  const getDrugName = () => {
    fetchDrugName(drugSearchString)
      .then((response) => response.data)
      .then((res) => {
        setDrugName(res.result);
      });
  };
  // drugDose
  const getDrugDose = () => {
    fetchDrugDose()
      .then((response) => {
        //
        setDrugDose(response.data.result);
      })
      .catch((response) => {
        //
      });
  };

  //   drugInstruction
  const getDrugInstruction = () => {
    fetchDrugInstructions()
      .then((response) => response.data)
      .then((res) => {
        //
        setDrugInstrucForm(res.result);
      });
  };

  //   drugRoute
  const getDrugRoute = () => {
    fetchDrugRoute()
      .then((response) => response.data)
      .then((res) => {
        //
        setDrugRoute(res.result);
      });
  };

  ////focus input on enter
  const handleInputFocus = (event, index) => {
    //

    let nextIndex;
    if (index === 6) {
      nextIndex = 0;
    } else {
      nextIndex = index + 1;
    }

    inputRefs.current[nextIndex].focus();
  };
  /////

  const renderActions = (row, index) => {
    const handleEditRow = (row, rowIndex) => {
      methods.setValue("drugName", {
        value: row.itemName,
        label: row.itemName,
      });
      methods.setValue("dosage", {
        value: row.frequency,
        label: row.frequency,
      });
      methods.setValue("duration", row.dose);
      methods.setValue("route", { value: row.route, label: row.route });
      methods.setValue("instructions", row.instructions);
      methods.setValue("isCurrentMedicine", row.isCurrentMedicine);
      setEditIndex(rowIndex);
    };

    const handleDeleteRow = (row, rowIndex) => {
      let temp = [...allMedicationData];

      let updated = temp.map((item, arrIndex) =>
        arrIndex === rowIndex ? { ...item, isDelete: true } : item
      );

      let deletedItems = [];
      let notDeletedItems = [];

      updated.forEach((item) => {
        if (item.isDelete === true) {
          deletedItems.push(item);
        } else {
          notDeletedItems.push(item);
        }
      });

      // Update the state with deleted items and allMedicationData
      setDeletedMedicationData((prev) => [...prev, ...deletedItems]);
      setAllMedicationData(notDeletedItems);
    };

    return (
      <>
        <div>
          {allMedicationData.length > 0 ? (
            //&&
            //allMedicationData.filter((item) => !item.isDelete).length
            <>
              <EditOnIcon
                title={"Edit"}
                onClick={() => handleEditRow(row, index)}
              />
              <DeleteOnIcon
                title={"Delete"}
                onClick={() => handleDeleteRow(row, index)}
              />
            </>
          ) : null}
        </div>
      </>
    );
  };

  return (
    <div>
      {/* <Button onClick={handleOpen}>Open modal</Button> */}
      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={ModalStyle} className="max-h-[88%] xl:max-h-[100%]">
          <CancelPresentationIconButton
            onClick={() => {
              handleClose();
              //   setEdit(false);
              //   reset(defaultValues);
            }}
          />
          <form
          //onSubmit={methods.handleSubmit(onsubmit)}
          >
            <div>
              <div className="text-black font-bold text-lg pb-3">
                Prescription
              </div>
              <div className="grid md:grid-cols-6 lg:grid-cols-4 gap-3">
                {/* drugName */}
                <div className="md:col-span-3 lg:col-span-1">
                  <CreateableSelect
                    name="drugName"
                    placeholder="Search Item"
                    dataArray={drugName}
                    onInputChange={(e) => {
                      setDrugSearchString(e);
                    }}
                    menuPlacement={"bottom"}
                    searchIcon={true}
                    error={errors.drugName}
                    control={control}
                    isClearable={true}
                    //
                    referance={(inputRef) => {
                      if (inputRef) {
                        inputRefs.current.push(inputRef);
                      }
                    }}
                    inputRef={{
                      ...register("drugName", {
                        onChange: (e) => {
                          // handleInputFocus(e, 0);

                          if (e.target.value !== null) {
                            handleInputFocus(e, 0);
                          }
                        },
                      }),
                    }}
                  />
                </div>

                {/* dosage */}
                <div className="md:col-span-3 lg:col-span-1">
                  <DropdownField
                    control={control}
                    dataArray={drugDose}
                    name="dosage"
                    menuPlacement={"bottom"}
                    placeholder="Frequency *"
                    error={errors.dosage}
                    referance={(inputRef) => {
                      if (inputRef) {
                        inputRefs.current.push(inputRef);
                      }
                    }}
                    inputRef={{
                      ...register("dosage", {
                        onChange: (e) => {
                          handleInputFocus(e, 1);
                          if (e.target.value !== null) {
                            //handleInputFocus(e, 1);
                          }
                        },
                      }),
                    }}
                  />
                </div>

                {/* duration/frequncy */}
                <div className="md:col-span-3 lg:col-span-1">
                  <InputField
                    name="duration"
                    variant="outlined"
                    label="Dosage * "
                    error={errors.duration}
                    control={control}
                    // disabled={isDisabled}
                    inputProps={{ maxLength: 100 }}
                    //

                    inputRef={(inputRef) => {
                      if (inputRef) {
                        inputRefs.current.push(inputRef);
                      }
                    }}
                    onKeyDown={(e) =>
                      e.key === "Enter" && handleInputFocus(e, 2)
                    }
                  />
                </div>

                {/* route */}
                <div className="md:col-span-3 lg:col-span-1">
                  <DropdownField
                    control={control}
                    error={errors.route}
                    name="route"
                    placeholder="Route*"
                    dataArray={drugRoute}
                    isSearchable={false}
                    menuPlacement={"bottom"}
                    //
                    referance={(inputRef) => {
                      if (inputRef) {
                        inputRefs.current.push(inputRef);
                      }
                    }}
                    inputRef={{
                      ...register("route", {
                        onChange: (e) => {
                          if (e.target.value !== null) {
                            handleInputFocus(e, 3);
                          }
                        },
                      }),
                    }}
                  />
                </div>

                {/* instructions */}
                <div className="md:col-span-3 lg:col-span-1">
                  <InputField
                    control={control}
                    // error={errors.instructions}
                    label="Instructions"
                    name="instructions"
                    isSearchable={false}
                    //
                    onKeyDown={(e) =>
                      e.key === "Enter" && handleInputFocus(e, 4)
                    }
                    inputRef={(inputRef) => {
                      if (inputRef) {
                        inputRefs.current.push(inputRef);
                      }
                    }}
                  />
                </div>

                <div className="md:col-span-2 lg:col-span-1">
                  <CheckBoxField
                    control={control}
                    name="isCurrentMedicine"
                    label="Is Current Medicine"
                    //
                    onKeyDown={(e) => handleInputFocus(e, 5)}
                    referance={(inputRef) => {
                      if (inputRef) {
                        inputRefs.current.push(inputRef.childNodes[0]);
                      }
                    }}
                  />
                </div>

                <div className="flex justify-end lg:col-span-2 md:col-span-1">
                  <div>
                    <CommonButton
                      //type="submit"
                      label={editIndex !== null ? "Update" : "Add"}
                      className="bg-customGreen text-white"
                      referance={(inputRef) => {
                        if (inputRef) {
                          inputRefs.current.push(inputRef);
                        }
                      }}
                      onClick={methods.handleSubmit(onsubmit)}
                      onKeyDown={(e) => {
                        handleInputFocus(e, 6);

                        methods.handleSubmit(onsubmit);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="pt-2">
                <CommonDynamicTableNew
                  dataResult={
                    allMedicationData.length > 0
                      ? allMedicationData
                      : medicationHeaders
                  }
                  setAllMedicationData={setAllMedicationData}
                  renderActions={renderActions}
                  removeHeaders={["medicationId", "isDelete"]}
                  tableClass="h-52 capitalize"
                  highlightRow={false}
                />
              </div>
              <div className="flex justify-end py-3">
                <CommonButton
                  // type="submit"
                  label={"Save"}
                  className="bg-customGreen text-white"
                  onClick={() => {
                    handleClose();
                  }}
                />
              </div>
            </div>
          </form>
        </Box>
      </Modal>
    </div>
  );
}
